
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import PageTopTitle from "../../shared/PageTopTitle"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import Button from "../../shared/button/Btn"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import InputTextarea from "../../shared/input/new/InputTextarea"
import { FaCheck } from "react-icons/fa6";
import { updateBlockedUsersAdmin } from "../../../features/admin3/admin3Slice"


const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 870px;
        max-width: 900px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .content{
            margin: 50px 30px;
            display: flex;
            width: 100%;
            flex-direction: column;
            align-items: center; 
            gap: 15px;
            .row{
                width: 640px;

            }
            .check-container{
                display: flex;
                flex-direction: column;
                gap: 10px;
                width: 640px;
                justify-content: flex-start;
                .check-row{
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-md);
                    .red{
                        width: 20px;
                        height: 20px;
                        background-color: #E85446;
                    }
                    .yellow{
                        width: 20px;
                        height: 20px;
                        background-color: #f3d825;
                    }
                    .check{
                        width: 20px;
                        height: 20px;
                        border: 2px solid ${({ theme }) => theme.mainBorderColor};
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        cursor: pointer;
                    }
                }
            }
        }
        .errors{
            width: 640px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            gap: 10px;
            margin-bottom: 20px;
            p{
                font-size: var(--font-size-xs);
                font-weight: var(--font-weight-md);
                color: var(--color-main);
            }
        }
        .button-grp{
            height: 80px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            width: 640px;
            border-top: 1px solid;
            border-color: ${({ theme }) => theme.mainBorderColor};
            margin-right: 8px;
        }
    }

    @media (max-width: 650px){
        .modal{
            width: 100% !important;
            .row{
                width: 90% !important;
            }
        }
    }
`
const checkData = [
    {
        id: 1,
        text: "Firmaların Engelinde Kalsın",
        state: 1
    },
    {
        id: 2,
        text: "Kamyoon Olarak Engelle",
        state: 2
    }
]

const AdminKaraListeSonucModal = () => {
    
    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const { selectedBlockedUserAdmin } = useSelector(state => state.admin3)
    const { lockScroll, unlockScroll } = useScrollLock();

    const [isSubmitted, setIsSubmitted] = useState(false)
    const [description, setDescription] = useState("")
    const [check, setCheck] = useState(null)

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])


    const handleSubmit = () => {
        setIsSubmitted(true)
        if(description && check){
            dispatch(updateBlockedUsersAdmin({
                id: selectedBlockedUserAdmin.id,
                state: check?.state,
                description: description
            }))
        }
    }

    useEffect(() => {
        if(selectedBlockedUserAdmin?.description || selectedBlockedUserAdmin?.state){
            setDescription(selectedBlockedUserAdmin?.description)
            setCheck(checkData.find(item => item.state === selectedBlockedUserAdmin?.state))
        }
    }, [selectedBlockedUserAdmin])

  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))} >
    <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
    <PageTopTitle title={"Admin Engellenen Üye"}/>
    <div className="content">
        <div className="row">
            <InputTextarea data={description} setData={(e) => setDescription(e.target.value)} inputWidth={"100%"} labelText={"İnceleme Sonucu"} name={"description"} />
        </div>
        <div className="check-container">
            {checkData.map((item, index) => (
                <div className="check-row" onClick={() => setCheck(check?.state !== item?.state ? item : null )} key={index}>
                    {item?.state === 1 ? <div className="yellow" /> : <div className="red"/> }
                    <div className="check">
                        {check?.state === item?.state ? <FaCheck /> : ""}
                    </div>
                    <p>{item.text}</p>
                </div>
            ))}
        </div>
    </div>

    <div className="errors">
        {isSubmitted && !description && <p>Açıklama yazınız.</p> }
        {isSubmitted && !check && <p>Engel türü seçiniz.</p> }
    </div>
    
    <div className='button-grp'>
        <Button handleClick={handleSubmit} bgColor="#E85446" width="150px" color="#fff">Kaydet</Button>
        <Button handleClick={() => dispatch(showModal(null))} bgColor="transparent" width="150px" color="#E85446">Kapat</Button>
    </div>
    </div>
</ModalContainer>
  )
}

export default AdminKaraListeSonucModal